<template>
  <div class="header">
    <div v-if="isADMIN_MEMBER" class="text-center mt-3 red bold">
      代理ログイン中
    </div>
    <div class="md-toolbar-row mb-md-3 mb-lg-0">
      <div class="md-toolbar-section-start">
        <router-link v-if="isActiveLogo" :to="{ name: 'Login' }">
          <span class="md-title"><img :src="logoFile" id="header-logo" /></span>
        </router-link>
        <span v-else class="md-title">
          <img :src="logoFile" id="header-logo" />
        </span>
      </div>

      <div class="md-toolbar-section-end">
        <!--
        <md-button class="md-primary md-dense" v-on:click.prevent="changeLang">
          {{ $t("header.lang") }}
        </md-button>
        -->
        <div v-if="isLogin">
          <md-button
            v-if="isMobile"
            class="md-icon-button width-50 height-50"
            @click="$emit('changeMenuVisible')"
          >
            <md-icon class="md-size-2x">menu</md-icon>
          </md-button>
          <div
            v-else
            class="person-icon-wrapper"
            @mouseover="setShowPersonFlg(true)"
            @mouseleave="setShowPersonFlg(false)"
          >
            <div class="col-md-12">
              <md-button class="md-icon-button">
                <md-icon class="md-size-2x bg-black">person</md-icon>
              </md-button>
            </div>
            <p class="text-center">{{ userName }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="md-toolbar-row" v-if="isLogin && !isMobile && !isAdmin">
      <md-tabs
        :class="[isProd ? 'md-primary' : 'md-accent']"
        md-alignment="fixed"
        :md-active-tab="activeTab"
      >
        <md-tab
          id="tab-home"
          md-icon="home"
          md-label="ホーム"
          :to="{ name: 'Home' }"
        />
        <md-tab
          id="tab-amount"
          md-icon="monetization_on"
          md-label="料金・納期"
          :to="{ name: 'TrialIndex' }"
        />
        <md-tab
          id="tab-estimate"
          md-icon="article"
          md-label="お見積り履歴"
          :to="{ name: 'EstimateIndex' }"
        />
        <md-tab
          id="tab-order"
          md-icon="assignment_turned_in"
          md-label="発注"
          @click="checkYoshin"
        />
        <md-tab
          id="tab-history"
          md-icon="history"
          md-label="発注履歴"
          :to="{ name: 'HistoryIndex' }"
        />
        <!--<md-tab id="tab-receipt" md-icon="receipt" :md-label="$t('header.receipt')"></md-tab>-->
        <md-tab
          id="tab-setting"
          md-icon="build"
          md-label="設定"
          :to="{ name: 'SettingIndex' }"
        />
        <md-tab
          id="tab-inquiry"
          md-icon="contact_mail"
          md-label="お問い合わせ"
          :to="{ name: 'InquiryIndex' }"
        />
      </md-tabs>
    </div>

    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      :md-active.sync="isYoshiFukaModal"
      md-title=""
      :md-content="getHcbApiErrorMessage('untrust')"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="true"
      @md-confirm="gotoInquiry"
    />
  </div>
</template>

<script>
import Mixin from './mixin/Mixin'
import Store from '@/store/index.js'
export default {
  name: 'Header',
  mixins: [Mixin],
  props: {
    isPersonOnmouse: {
      type: Boolean,
      default: false,
    },
    routeName: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    logoFile: '/static/logo1.png',
    showPersonFlg: false,
    activeTab: '',
    isYoshiFukaModal: false, // 与信不可モーダル表示フラグ
  }),
  created() {
    this.setActiveTab(this.$route.name)
  },
  methods: {
    changeLang() {
      this.$emit('changeLanguage')
    },
    async setShowPersonFlg(flg) {
      if (!flg) {
        await this.sleep(350)
      }
      // ユーザブロック上にカーソルがない場合に判定
      if (!this.isPersonOnmouse) {
        this.$emit('setShowPerson', flg)
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    setActiveTab(toName) {
      if (!toName) return
      if (toName.match(/Home/)) {
        this.activeTab = 'tab-home'
      } else if (toName.match(/Order/)) {
        this.activeTab = 'tab-order'
      } else if (toName.match(/History/)) {
        this.activeTab = 'tab-history'
      } else if (toName.match(/Trial/)) {
        this.activeTab = 'tab-amount'
      } else if (toName.match(/Setting/)) {
        this.activeTab = 'tab-setting'
      } else if (toName.match(/Inquiry/)) {
        this.activeTab = 'tab-inquiry'
      } else if (toName.match(/Estimate/)) {
        this.activeTab = 'tab-estimate'
      }
    },
    /**
     * 与信不可か確認し不可の場合はアラートを表示
     * 問題ない場合は発注画面に遷移する
     */
    checkYoshin() {
      if (this.isYoshinFuka) this.isYoshiFukaModal = true
      else this.$router.push({ name: 'OrderIndex' })
    },
  },
  computed: {
    isActiveLogo() {
      const routeName = this.$router.history.current.name
      return !(routeName === 'Maintenance')
    },
    screenWidth() {
      return Store.state.screen.width
    },
    userName() {
      return (
        (Store.state.user.data.TANTO_MEI_SEI || '') +
        (Store.state.user.data.TANTO_MEI || '')
      )
    },
  },
  watch: {
    routeName(val) {
      this.setActiveTab(val)
    },
  },
}
</script>

<style lang="sass" scoped>
.person-icon-wrapper
  padding: 20px
  height: 80px
#header-logo
  width: 180px
</style>



// WEBPACK FOOTER //
// src/components/Header.vue